import React from 'react';
import { useDemandFilters } from '@/features/demands/hooks/useDemandFilters';
import AdvancedFilters, { FilterConfig } from '@components/AdvancedFilters';

/**
 * Componente de filtros para a página de demandas.
 * Usa o componente centralizado AdvancedFilters com configuração específica para demandas.
 */
export const DemandFilters: React.FC = () => {
  // Garante que side-effects/config de filtros sejam aplicados
  useDemandFilters();

  const filterConfig: FilterConfig = {
    showClientFilter: true,
    showDateRangeFilter: true,
    showCategoryFilter: true,
    showStatusFilter: true,
    showPriorityFilter: true,
    showQrCodeFilter: true,
    showSimilarOnlyFilter: true,
    showAssigneeFilter: true,
    showProviderFilter: true,
    pageType: 'demands',
    variant: 'compact',
  };

  return <AdvancedFilters config={filterConfig} />;
};

export default DemandFilters;
